import { render, staticRenderFns } from "./LoginWithEmail.vue?vue&type=template&id=2e0a85bf&scoped=true&"
import script from "./LoginWithEmail.vue?vue&type=script&lang=js&"
export * from "./LoginWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithEmail.vue?vue&type=style&index=0&id=2e0a85bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a85bf",
  null
  
)

/* custom blocks */
import block0 from "./LoginWithEmail.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports